import { Interaction, Tooltip } from "chart.js";
import { pointRadial } from "d3";
import React from "react";
import { Bar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";

const AgGraph = ({ dates, repayment, type }) => {
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(2)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toString();
  }
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    let floatedValue = parseFloat(num);
    return floatedValue.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }
  const options = {
    maintainAspectRatio: false,

    responsive: true,
    interaction: {
      intersect: true,
      mode: "index",
    },
    scales: {
      y: {
        ticks: {
          //   callback: function (value, index, values) {
          //     return indianNumberFormat(value); // Add a dollar sign and format to two decimal places
          //   },
          font: {
            size: 10, // Adjust font size to your preference (in pixels)
          },
        },
        suggestedMin: 0,
        beginAtZero: true,
        stacked: false,
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: `${
            type === "success" ? "Successful Request" : "Failed Request"
          }`,
          font: "Inter",
          style: "none", // Label for the y-axis
        },
      },

      x: {
        stacked: true,
        ticks: {
          font: {
            size: 9, // Adjust font size to your preference (in pixels)
          },
        },

        // grid: {
        //   display: false,
        // },
      },
      // y: {
      //   stacked: true,
      //   grid: {
      //     display: false,
      //   },
      //   title: {
      //     display: true,
      //     text: "Amount ($)",
      //     font: "Inter",
      //     style: "none", // Label for the y-axis
      //   },
      // },
    },
    plugins: {
      tooltip: {
        backgroundColor: "#656565",
        boxPadding: 7,
        padding: 15,
        cornerRadius: 4,
        bodyColor: "white",
        caretSize: 0,
        bodyFont: {
          size: 12,
          lineHeight: 2,
          weight: "normal",
        },
      },
      layout: {
        padding: {
          bottom: 100, // Increase the top padding to create space between legend and graph
        },
      },
      legend: {
        display: false,
      },
    },
  };

  const data = {
    labels: dates,
    datasets: [
      {
        label: "Fetch",
        data: repayment, //[0, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        // backgroundColor: "#0070d2",
        borderColor: "#9d53f2",
        pointRadius: 0,
        backgroundColor: "#9d53f2",
      },
    ],
  };
  return (
    <div className="   mt-[0px] ">
      <Line data={data} options={options} height={"260px"} width={"320px"} />
    </div>
  );
};

export default AgGraph;
